import types from '../types';
import { duckConstants } from '../../../constants';
import { extractState } from '../../../utilities/combineUseReducer';

const reducer = (state, action) => {
  switch (action.type) {
    /* INTERVIEWER LIST */
    case types.GET_INTERVIEWER_LIST: {
      return state;
    }

    case types.GET_INTERVIEWER_LIST_SUCCESS: {
      return { ...state, lciInterviewerList: action.result };
    }

    case types.GET_INTERVIEWER_LIST_ERROR: {
      return { ...state, lciInterviewerList: action.result };
    }

    /* CODE MCQ LIST */
    case types.GET_ALL_CODE_MCQ: {
      return state;
    }

    case types.GET_ALL_CODE_MCQ_SUCCESS: {
      return { ...state, lciCodeChallengeList: action.result };
    }

    case types.GET_ALL_CODE_MCQ_ERROR: {
      return { ...state, lciCodeChallengeList: action.result };
    }

    /* SEARCH CANDIDATES */
    case types.SEARCH_CANDIDATES: {
      return { ...state, searchCandidates: action.searchCandidates, searchingCandidates: true };
    }

    case types.SEARCH_CANDIDATES_SUCCESS: {
      return { ...state, candidatesFound: action.result, searchingCandidates: false };
    }

    case types.SEARCH_CANDIDATES_ERROR: {
      return { ...state, candidatesFound: action.result, searchingCandidates: false };
    }

    case types.RESET_CANDIDATES_SEARCH_LIST: {
      return { ...state, candidatesFound: null, searchingCandidates: false };
    }

    /* GET CANDIDATES LCI INFO */
    case types.GET_LCI_CANDIDATE_INFO: {
      return state;
    }

    case types.GET_LCI_CANDIDATE_INFO_SUCCESS: {
      return { ...state, lciCandidateInfo: action.result };
    }

    case types.GET_LCI_CANDIDATE_INFO_ERROR: {
      return state;
    }

    /* GET LCI LISTING */
    case types.GET_LCI_LISTING: {
      return { ...state, getLCIListing: true, lciListingMessage: null };
    }

    case types.GET_LCI_LISTING_SUCCESS: {
      const lciListingMessage = { type: 'success' };
      return { ...state, getLCIListing: false, lciList: action.result, count: action.count, lciListingMessage };
    }

    case types.GET_LCI_LISTING_ERROR: {
      const lciListingMessage = { type: 'error' };
      return { ...state, getLCIListing: false, lciListingMessage };
    }

    case types.RESET_DATA: {
      return { ...state, lciCandidateInfo: null };
    }

    case types.REHYDRATE: {
      /* INITIAL STATE */
      const initialState = (state && state[stateKey]) ? { ...state[stateKey] } : extractState(duckConstants.LCI_SETUP_ROOT, stateKey);
      return { ...state, ...initialState };
    }

    default:
      return state;
  }
};

const stateKey = 'supporting';

export default { reducer, stateKey };
